module.exports = __webpack_public_path__ + "img/syz1.066b709c.jpg";